(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('pow', {
        templateUrl: 'views/components/views/pow/pow.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'powService', function ($stateParams, stateService, translateService, modalService, powService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let powKeyno = $stateParams.pow_keyno;

            let translations = {
                error: '',
                ok: ''
            };

            vm.model = {
                prodIdButtons: [
                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('product', { prod_id: vm.model.edit.prod_keyno }) }
                ],
                poKeynoButtons: [
                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('po', { po_keyno: vm.model.edit.po_keyno }) }
                ],
                edit: {},
                selectListOpStatuses: [],
                lockedSave: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATE SERVICE

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATE SERVICE

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadEdit() {
            	vm.model.edit = (await powService.getEdit({ pow_keyno: powKeyno }))[0];
            }

            async function loadOpStatuses() {
                vm.model.selectListOpStatuses = await powService.listOpStatuses();
            }

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

            vm.saveChanges = function () {
                vm.model.lockedSave = true;

                powService.saveObj(vm.model.edit).then((response) => {
                    if (response[0] && response[0].errorcode !== '0') {
                    	modalService.show({
                    		type: 'warning',
                    		title: translations.error,
                    		message: response[0].errormessage,
                    		buttons: [{
                    			label: translations.ok,
                    			cssClass: 'btn-warning',
                    			action: function (dialogItself) {
                    				dialogItself.close();
                    				vm.model.lockedSave = false;
                    			}
                    		}]
                    	});
                    } else {
                    	vm.model.lockedSave = false;
                    	stateService.back();
                    }
                });
            };

            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                translate();
                loadEdit();
                loadOpStatuses();
            };

            // #endregion ON INIT FUNCTION

        }]
    });
})();
